import { ThemeDefinition, VuetifyOptions } from 'vuetify';

const blackColor = '#24252C';
const whiteColor = '#FFFFFF';
const limeGreenColor = '#8BE535';
const bangladeshGreenColor = '#015D52';
const grey500Color = '#979797';
const grey100Color = '#E0E0E0';
const jikordLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    // vuetify colors
    error: '#FF4267',
    info: '#2196F3',
    primary: limeGreenColor,
    secondary: bangladeshGreenColor,
    success: limeGreenColor,
    warning: '#FB6B18',
    background: '#F6FAF5',
    'on-surface': blackColor,
    'on-primary': blackColor,
    'on-background': blackColor,

    // custom colors
    contrast: blackColor,
    systemPrimary: whiteColor,
    systemToolbar: whiteColor,
    navigationDrawer: limeGreenColor,
    neutral: grey500Color,
    'neutral-light': grey100Color,
    'neutral-border': whiteColor,
    'on-systemPrimary': blackColor,
    'on-navigationDrawer': grey500Color,
    'on-systemToolbar': blackColor,
  },
};

export const jikordTheme: VuetifyOptions['theme'] = {
  defaultTheme: 'light',
  themes: {
    light: jikordLightTheme,
  },
};
